import {Component, OnInit, inject} from '@angular/core';
import {I18nService} from '../_services/gui/i18n.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss'],
    imports: [TranslateModule]
})
export class NotAuthorizedComponent implements OnInit {
  private i18nService = inject(I18nService);


  ngOnInit() {
    this.i18nService.setTitle('title.not-authorized');
  }

}
